'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { forwardRef } from 'react';
import { FileUploaderButton, StyledText, FileUploadButtonIconBorder, SecondaryLabel } from './elements';
import { InternalProvider, useHoverState } from '../../../util';
import { Icon } from '../../Icon';
import { InlineLoader } from '../../Loaders';
export const FileUploadButton = /*#__PURE__*/forwardRef(({
  iconSrc = 'plus-add',
  label,
  secondaryLabel,
  disabled = false,
  isLoading = false,
  isPrimaryAction = false,
  onClick,
  ...rest
}, fRef) => {
  const {
    hoverState,
    ...onMouseEvents
  } = useHoverState(disabled);
  return /*#__PURE__*/React.createElement(InternalProvider, null, /*#__PURE__*/React.createElement(FileUploaderButton, _extends({
    disabled: disabled,
    onClick: e => {
      !isLoading && (onClick === null || onClick === void 0 ? void 0 : onClick(e));
    },
    isLoading: isLoading,
    hoverState: hoverState
  }, onMouseEvents, rest, {
    ref: fRef
  }), isLoading ? /*#__PURE__*/React.createElement(InlineLoader, {
    "data-testid": "file-upload-button-loading-spinner",
    width: "2rem"
  }) : iconSrc && /*#__PURE__*/React.createElement(FileUploadButtonIconBorder, {
    disabled: disabled,
    isPrimaryAction: isPrimaryAction,
    hoverState: hoverState
  }, /*#__PURE__*/React.createElement(Icon.Compat, {
    src: iconSrc,
    size: 'medium'
  })), /*#__PURE__*/React.createElement(StyledText, {
    size: 2,
    weight: "base",
    forwardedAs: 'p',
    isLoading: isLoading,
    disabled: disabled,
    hoverState: hoverState
  }, label), secondaryLabel && /*#__PURE__*/React.createElement(SecondaryLabel, {
    size: 1,
    weight: "base",
    forwardedAs: 'p',
    isLoading: isLoading,
    disabled: disabled,
    hoverState: hoverState
  }, secondaryLabel)));
});